import { mediaQuery } from '@arcade/web'

const breakpoints = {
  /** Targets device width >= 760px */
  tablet: mediaQuery.tablet,
  /**
   * Targets device width >= 1024px
   * @deprecated Try to avoid using this breakpoint and opt for tablet breakpoint instead since tablet = desktop.
   * This can still be used if absolutely necessary for legacy reasons
   */
  desktop: mediaQuery.desktop,
  /** Targets device width >= 1440px */
  widescreen: mediaQuery.widescreen,
} as const

export type ThemeBreakpoints = typeof breakpoints

export default breakpoints
